module.exports = __webpack_public_path__ + "img/happyhour.f96b84ef.png";